import React, { useState } from "react";
import "./Contact.css";
import { FaWhatsapp } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("http://127.0.0.1:8000/contact/submit/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      console.log(data);
      alert("Form submitted successfully!");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div className="contact-wrapper">
      <div className="contact-info">
        <h2>How can we help you?</h2>
        <p>
          Our team is here to help you access capital and grow on your terms.
          Check out the resources below and reach out directly if you have any questions.
        </p>

        <div className="contact-buttons">
          <button className="btn primary-btn">Call Us</button>
          <button className="btn secondary-btn">Email Us</button>
        </div>
      </div>

      <div className="contact-form-container">
        <h1>Contact Us</h1>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit">Submit</button>
        </form>

        <div className="contact-footer">
          <hr />
          <div className="contact-details">
            <div className="left-column">
              <p>triangleautos@hotmail.com</p>
              <a
                href="https://wa.me/923362046379"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                <FaWhatsapp className="whatsapp-icon" />
              </a>
            </div>
            <div className="right-column">
              <p>Karachi, Pakistan</p>
              <p>
                Plot# B - 292 & 293, Block - 1, <br />
                Metroville - 1, S.I.T.E, <br />
                Pakistan, Karachi.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
